"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ResponsiveDialogDrawer = void 0;
var _icons = require("@ori-ui/icons");
var _mui = require("@ori-ui/mui");
var _testidGenerator = _interopRequireDefault(require("@ori/testid-generator"));
var _clsx = _interopRequireDefault(require("clsx"));
var _react = require("react");
var _responsiveDialogClasses = require("../../../responsiveDialogClasses");
var _styles = require("../styles");
var _constants = require("./constants");
var _styles2 = require("./styles");
var _jsxRuntime = require("react/jsx-runtime");
const ResponsiveDialogDrawer = ({
  open,
  onClose,
  anchor = 'right',
  header: headerProp,
  children,
  hideCloseButton = false,
  footer,
  className,
  isLoading,
  zIndex,
  ...props
}) => {
  const {
    getTestId
  } = (0, _testidGenerator.default)();
  const hasFooter = footer !== undefined;
  const shouldRenderFooter = hasFooter && !isLoading;
  const rootClassName = (0, _clsx.default)(_responsiveDialogClasses.responsiveDialogClasses.drawer, className);
  const drawerFooterClassName = (0, _clsx.default)(_responsiveDialogClasses.responsiveDialogClasses.footer, _responsiveDialogClasses.responsiveDialogClasses.drawerFooter);
  const drawerContentClassName = (0, _clsx.default)(_responsiveDialogClasses.responsiveDialogClasses.content, _responsiveDialogClasses.responsiveDialogClasses.drawerContent);
  const header = (0, _react.useMemo)(() => {
    if (headerProp === undefined) {
      return null;
    }
    return /*#__PURE__*/(0, _jsxRuntime.jsx)(_styles2.HeaderContainer, {
      className: _responsiveDialogClasses.responsiveDialogClasses.drawerTitleContainer,
      "data-testid": getTestId(_constants.RESPONSIVE_DIALOG_DRAWER_HEADER),
      children: typeof headerProp === 'string' ? /*#__PURE__*/(0, _jsxRuntime.jsx)(_mui.Typography, {
        variant: "h5",
        component: "h5",
        textAlign: "center",
        "data-testid": getTestId(_constants.RESPONSIVE_DIALOG_DRAWER_TITLE),
        className: _responsiveDialogClasses.responsiveDialogClasses.drawerTitle,
        children: headerProp
      }) : headerProp
    });
  }, [getTestId, headerProp]);
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_styles2.StyledDrawer, {
    "data-testid": getTestId(_constants.RESPONSIVE_DIALOG_DRAWER),
    open: open,
    anchor: anchor,
    zIndex: zIndex,
    onClose: onClose,
    ...props,
    children: /*#__PURE__*/(0, _jsxRuntime.jsxs)(_styles2.Root, {
      elevation: 0,
      hasFooter: hasFooter,
      className: rootClassName,
      children: [header, /*#__PURE__*/(0, _jsxRuntime.jsx)(_styles.Content, {
        "data-testid": getTestId(_constants.RESPONSIVE_DIALOG_DRAWER_CONTENT),
        className: drawerContentClassName,
        isLoading: isLoading,
        children: children
      }), !hideCloseButton ? /*#__PURE__*/(0, _jsxRuntime.jsx)(_styles2.CloseButton, {
        color: "default",
        variant: "text",
        "data-testid": getTestId(_constants.RESPONSIVE_DIALOG_DRAWER_CLOSE_BUTTON),
        className: _responsiveDialogClasses.responsiveDialogClasses.drawerCloseButton,
        onClick: onClose,
        children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_icons.Clear, {
          fontSize: "small",
          color: "inherit"
        })
      }) : null, shouldRenderFooter ? /*#__PURE__*/(0, _jsxRuntime.jsx)(_styles.FooterContainer, {
        "data-testid": getTestId(_constants.RESPONSIVE_DIALOG_DRAWER_FOOTER),
        className: drawerFooterClassName,
        children: footer
      }) : null]
    })
  });
};
exports.ResponsiveDialogDrawer = ResponsiveDialogDrawer;
